import identity from "lodash/fp/identity";

class ReportGeneratorPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default ReportGeneratorPageTransform;



// WEBPACK FOOTER //
// ./src/pages/reportGenerator/reportGenerator.transforms.js